import React, { useEffect, useState } from 'react';
import { CSSProperties } from 'react';
import '../App.css';
import '../index.css';

interface MusicEntry { no: number; name: string; }

function SearchMusic() {
    const [musicList, setMusicList] = useState<MusicEntry[]>([]);
    const [search, setSearch] = useState(''); // <--- Make sure this exists!

    const r2BaseUrl = process.env.REACT_APP_R2_BASE_URL || '';

useEffect(() => {
    const r2BaseUrl = process.env.REACT_APP_R2_BASE_URL || '';

    fetch(`${r2BaseUrl}/music/musiclist`)
        .then(response => response.text())
.then(data => {
    const entries: MusicEntry[] = [];
    data.split(/\r?\n/).forEach((raw, idx) => {
        const line = raw.trim();
        if (line !== '' && !line.startsWith('#')) {
            entries.push({ no: idx + 1, name: line });
        }
    });
    setMusicList(entries);
})
        .catch(() => {});
}, []); // Match the empty dependency array from ViewMusic

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(
            event.target.value
            .replace('','김')
            .replace('','일')
            .replace('','성')
            .replace('','김')
            .replace('','정')
            .replace('','일')
            .replace('','김')
            .replace('','정')
            .replace('','은')
        );
    };
    const liStyle: CSSProperties = {
        padding: 0.2 + 'em',
        margin: 0.2 + 'em',
    };
    const aStyle: CSSProperties = {
        color: 'black',
        textDecorationColor: 'gray',
        textDecorationStyle: 'dotted',
    };

const searchResultsList = musicList
    .filter(({ name }) => {
        if (!search) return true;
        return name.toLowerCase().includes(search.toLowerCase());
    })
    .map(({ no, name }) => (
    <li key={no} style={liStyle}>
        <a href={`/${no}`} style={aStyle}>
            {name
                    .replace('김일성','')
                    .replace('김정일','')
                    .replace('김정은','')
                    .split('@')[0] // Cleaner than substring/indexOf
                }
            </a>
        </li>
    ));
    
    const listStyle: CSSProperties = {
        listStyle: 'none',
        listStyleType: 'none',
        padding: 0,
        margin: 1 + 'em',
    };
    const titleStyle: CSSProperties = {
        margin: 0.5 + 'em',
    };
    const inputStyle: CSSProperties = {
        margin: 0.5 + 'em',
        padding: 0.2 + 'em',
        fontSize: 1 + 'em',
        width: 30 + 'em',
        maxWidth: 100 + '%',
        fontFamily: 'KP CheonRiMa',
    };
    return (
        <>
            <h1 style={titleStyle}>
                음악마당
            </h1>
            <input
                style={inputStyle}
                type="text"
                placeholder="검색어를 입력하시오."
                value={search}
                onChange={handleSearchChange}
            />
            <ul style={listStyle}>{searchResultsList}</ul>
        </>
    );

}

export default SearchMusic;
